import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ReduxState } from 'kb-shared';

import Book from '../Book';

type Props = RouteComponentProps & {
  skipToSignUp?: boolean;
};

const SignUp = (props: Props) => {
  const { skipToSignUp } = props;

  return <Book skipToSignUp={skipToSignUp} />;
};

const mapStateToProps = ({ patient: { isLoggedIn } }: ReduxState) => ({
  isLoggedIn: isLoggedIn
});

export default connect(mapStateToProps, null)(SignUp);
